<template>
  <div>
    <v-divider />
    <v-dialog v-model="isModalOpen" max-width="642px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
        <span>{{ cameraModalTitle }}</span>

        <v-btn icon @click="closeCameraModal">
          X </v-btn>
        </v-card-title>

        <v-card-text class="pa-0" style="justify-items: center;">
        <div class="video-container">
          <div v-if="isLoadingCamera" class="loading-overlay">
            <loading-animation></loading-animation>
          </div>

          <iframe
            :src="camUrl"
            width="100%"
            height="100%"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen>
          </iframe>
        </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card class="transparent" flat>
      <v-tabs color="secondary lighten-1" background-color="transparent" v-model="tab">
<!--        <v-tabs-slider color="secondary lighten-1"></v-tabs-slider>-->
        <v-tab href="#saic">SAIC</v-tab>
        <v-tab href="#reservoirs">Reservatórios</v-tab>
        <v-tab href="#waterTreatmentPlants">Estações de Tratamento de Água (ETAs)</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item value="saic" class="primary darken-2 elevation-0" >
          <v-card class="px-0" flat color="primary darken-2">
            <v-card-title class="px-0 py-6 title-item-text">
              <v-icon color="secondary lighten-1" left size="32">mdi-select-group</v-icon>
              Sistema de Abastecimento de Água Integrado de Curitiba e Região Metropolitana - SAIC
            </v-card-title>
            <v-card-text class="px-0 pt-2">
              <current-situation-reservoirs />
            </v-card-text>
          </v-card>

          <saic-current-situation-of-hydrological-data
            :reservoirSelected="saic"
            :volumesData="volumesData"
          >
          </saic-current-situation-of-hydrological-data>

          <saic-situation-by-period
            :basin="saic"
          >
          </saic-situation-by-period>
        </v-tab-item>
        <v-tab-item value="reservoirs">
          <div class="px-0" style="background: #2c343f">
            <v-row>
              <v-col cols="12">
                <v-card-title class="px-0 py-6 title-item-text">
                  <v-icon color="secondary lighten-1" left size="32">icon-infohidro-reservatorio</v-icon>
                  Reservatórios
                </v-card-title>
                <v-card-subtitle class="px-0 py-6">Selecione um reservatório para consultar os dados:</v-card-subtitle>
                <v-slide-group :show-arrows="false" v-model="reservoirSelected">
                  <v-slide-item v-for="(item,index) in reservoirsList" :key="index" v-slot="{ active, toggle }">
                    <v-btn large rounded outlined class="mr-2" :input-value="active" active-class="secondary white--text" @click="toggle">{{ item.text }}</v-btn>
                  </v-slide-item>
                </v-slide-group>
                <v-card-text class="px-0 pt-2 mt-5">
                  <div>
                    <h1 class="white--text" id="current-situation-title-text">Situação atual</h1>
                    <div class="my-2">
                      <v-icon color="secondary lighten-1" left size="18">icon-infohidro-reservatorio</v-icon>
                      <span class="white--text" id="saic-subtitle-text">{{ reservoirsList[reservoirSelected].text }}</span>
                    </div>
                    <hr style="display: block; border: 1px solid #D9D9D9;" />
                  </div>
                </v-card-text>
                <v-row>
                  <v-col cols="12">
                    <reservoir-supply-chart :reservoirSelected="reservoirsList[reservoirSelected]"></reservoir-supply-chart>
                  </v-col>
                  <v-col cols="12">
                    <water-supply-hydrological-data-reservoirs :reservoirSelected="reservoirsList[reservoirSelected]" />
                    <v-col v-if="reservoirsList[reservoirSelected].cameras" cols="12" class="mt-4">
                        <v-btn
                        v-for="(camera, cameraIndex) in reservoirsList[reservoirSelected].cameras"
                        :key="camera.url"
                        color="secondary"
                        class="mr-2 mb-2"
                        depressed
                        size="small"
                        variant="flat"
                        @click="openCameraModal(camera)"
                        >
                        <v-icon left size="16">mdi-camera</v-icon>
                        Câmera {{ cameraIndex + 1 }}
                        </v-btn>
                    </v-col>
                  </v-col>
                  <v-col cols="12">
                    <basins-situation-by-period
                      :basin="reservoirsList[reservoirSelected]"
                    ></basins-situation-by-period>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-tab-item>
        <v-tab-item value="waterTreatmentPlants">
          <div style="background: #2c343f">
            <v-row>
              <v-col cols="12">
                <v-card-title class="px-0 py-6 title-item-text">
                  <v-icon color="secondary lighten-1" left size="32">icon-infohidro-eta</v-icon>
                  Estações de Tratamento de Água (ETAs)
                </v-card-title>
                <v-card-subtitle class="px-0 py-6">Selecione uma estação para consultar os dados:</v-card-subtitle>
                <v-slide-group :show-arrows="false" v-model="stationSelected">
                  <v-slide-item v-for="(item,i) in stationsList" :key="i" v-slot="{ active, toggle }">
                    <v-btn large rounded outlined class="mr-2" :input-value="active" active-class="secondary white--text" @click="toggle">{{ item.text }}</v-btn>
                  </v-slide-item>
                </v-slide-group>
                <v-card-text class="px-0 pt-2 mt-5">
                  <div>
                    <h1 class="white--text current-situation-title-text">Situação atual</h1>
                    <div class="my-2">
                      <v-icon color="secondary lighten-1" left size="18">icon-infohidro-eta</v-icon>
                      <span class="white--text" id="station-subtitle-text">{{ stationsList[stationSelected].text }}</span>
                    </div>
                    <hr style="display: block; border: 1px solid #D9D9D9;" />
                  </div>
                </v-card-text>
                <v-row>
                  <v-col cols="12">
                    <current-situation-station-cards :station="stationsList[stationSelected]" />
                  </v-col>
                </v-row>
                <v-card-text class="px-0 pt-2 mt-5 mb-n8">
                  <div>
                    <h1 class="white--text current-situation-title-text">Estimativa de chuva</h1>
                    <div class="my-2">
                      <v-icon color="secondary lighten-1" left size="18">icon-infohidro-eta</v-icon>
                      <span class="white--text" id="station-subtitle-text">{{ stationsList[stationSelected].text }}</span>
                    </div>
                  </div>
                </v-card-text>
                <v-row>
                  <seasonal-rainfall-estimate :station="stationsList[stationSelected]" />
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import ReservoirSupplyChart from "./common/ReservoirSupplyChart.vue";
import CurrentSituationReservoirs from './saic/CurrentSituationReservoirs.vue';
import SaicSituationByPeriod from './saic/SaicSituationByPeriod.vue';
import WaterSupplyHydrologicalDataReservoirs from "./WaterSupplyHydrologicalDataReservoirs";
import BasinsSituationByPeriod from './basins/BasinsSituationByPeriod.vue';
import SaicCurrentSituationOfHydrologicalData from './saic/SaicCurrentSituationOfHydrologicalData.vue';
import CurrentSituationStationCards from "./stations/CurrentSituationStationCards";
import SeasonalRainfallEstimate from "./stations/SeasonalRainfallEstimate";
import LoadingAnimation from '../common/LoadingAnimation.vue';
export default {
  name: "NavigationProductsReservoirs",
  components: {
    SeasonalRainfallEstimate,
    CurrentSituationStationCards,
    WaterSupplyHydrologicalDataReservoirs,
    ReservoirSupplyChart,
    CurrentSituationReservoirs,
    SaicSituationByPeriod,
    BasinsSituationByPeriod,
    SaicCurrentSituationOfHydrologicalData,
    LoadingAnimation
  },
  props:['volumesData'],
  data: () => ({
    tab: 0,
    reservoirSelected: 0,
    reservoirsList : [
      {text: 'Iraí', codigo: 25424911, orgaoId: 7, tipoId: "H", locationid: 1665, cameras: [
        {label: "Câmera 1", url: "/camera-stream/stream/Irai"},
        {label: "Câmera 2", url: "/camera-stream/stream/Irai_2"},
      ]},
      {text: 'Passaúna', codigo: 25534939, orgaoId: 7, tipoId: "H", locationid: 1662, cameras: [
        {label: "Câmera 1", url: "/camera-stream/stream/Passauna"},
        {label: "Câmera 2", url: "/camera-stream/stream/Passauna_2"},
      ]},
      {text: 'Piraquara I', codigo: 25504902, orgaoId: 7, tipoId: "H", locationid: 1667, cameras: [
        {label: "Câmera 1", url: "/camera-stream/stream/Piraquara1"},
        {label: "Câmera 2", url: "/camera-stream/stream/Piraquara1_2"},
      ]},
      {text: 'Piraquara II', codigo: 25484909, orgaoId: 7, tipoId: "H", locationid: 1667, cameras: [
        {label: "Câmera 1", url: "/camera-stream/stream/Piraquara2"},
        {label: "Câmera 2", url: "/camera-stream/stream/Piraquara2_2"},
      ]},
      {text: 'Miringuava', codigo: 25644908, orgaoId: 7, tipoId: "P", locationid: 1554 },
    ],
    stationSelected: 0,
    stationsList : [
      {text: 'Iguaçu', locationid: 1621, sia: '557' },
      {text: 'Iraí', locationid: 1665, sia: '77b' },
      {text: 'Miringuava', locationid: 1554, sia: '403' },
      {text: 'Passaúna', locationid: 1662, sia: '76' },
    ],
    saic: {text: "SAIC", codigo: "25424911,25534939,25504902,25484909,25644908", locationid: [1665,1662,1667,1667/* ,1554 */]},
    isModalOpen: false,
    isLoadingCamera: true,
    loadingTimer: null,
    camUrl: "about:blank",
    cameraSelected: undefined,
  }),
  watch: {
    tab(value) {
      this.recordGtagEvent('tabs',value);
    },
    reservoirSelected(){
        this.recordGtagEvent('slide-group', this.tab);
    },
    stationSelected() {
      this.recordGtagEvent('slide-group', this.tab);
    },
    quotas(value){
      const reservoirQuota = JSON.parse(JSON.stringify(value[0].parametros));
      this.reservoirsList[this.reservoirSelected]["COTA_MAXIMA_OPERACIONAL"] = reservoirQuota.COTA_MAXIMA_OPERACIONAL;
      this.reservoirsList[this.reservoirSelected]["COTA_MINIMA_OPERACIONAL"] = reservoirQuota.COTA_MINIMA_OPERACIONAL;
      this.reservoirsList[this.reservoirSelected]["VOLUME_RESERVA_TECNICA"] = reservoirQuota.VOLUME_RESERVA_TECNICA;
    },
  },
  computed: {
    quotas() {
      return this.$store.getters.quotas
    },
    cameraModalTitle() {
      const reservoirName = this.reservoirsList[this.reservoirSelected].text;
      const cameraLabel = this.cameraSelected ? ` - ${this.cameraSelected}` : '';
      return `Câmera ao Vivo - Reservatório ${reservoirName}${cameraLabel}`;
    },
  },
  methods: {
    async recordGtagEvent(watch_event, tab_selected) {
      var item_id = 0; // for SAIC
      if (tab_selected === "reservoirs") {
        item_id = this.reservoirsList[this.reservoirSelected].codigo;
      }
      else if (tab_selected === "waterTreatmentPlants") {
        item_id = this.stationsList[this.stationSelected].locationid;
      }

      var event_name = watch_event;
      var event_label = "tab_item";
      if (watch_event != "tabs") {
        event_label = "slide-group_item";
      }

      this.$gtag.event(event_name+'_watersupply_ProductsReservoirs-'+tab_selected, {
        'event_category': 'ProductsReservoirs - '+tab_selected,
        'event_label': event_label,
        'value': item_id
      });
    },
    openCameraModal(camera) {
      this.isModalOpen = true;
      this.isLoadingCamera = true;
      this.cameraSelected = camera.label;
      this.camUrl = camera.url;

      this.loadingTimer = setTimeout(() => {
        this.isLoadingCamera = false;
      }, 2500);
    },
    closeCameraModal() {
      if (this.loadingTimer) {
        clearTimeout(this.loadingTimer);
      }

      this.camUrl = 'about:blank';
      this.cameraSelected = undefined;

      setTimeout(() => {
        this.isModalOpen = false;
        this.isLoadingCamera = true;
      }, 100);
    },
  }
}
</script>

<style scoped>
.v-tab{
  text-transform: none;
}

.title-item-text{
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
}
.current-situation-title-text{
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
}

#reservoir-subtitle-text{
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
}

#station-subtitle-text{
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
}
.video-container {
  width: 100%;
  aspect-ratio: 16 / 9;
  justify-items: center;
  overflow: hidden;
}
.loading-overlay {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
